import axios from 'axios';
import { ProductDeclaration } from '../types/product-declaration.type';

// GET
// /ewosapi/v2/order/batches/{customerNumber}/{orderNumber}
export const getProductDeclaration = async (customerNumber: string, orderNumber: string): Promise<ProductDeclaration> => {
  // return ProductDeclarationData;
  const res = await axios.get<ProductDeclaration>(`/ewosapi/v1/order/batches/${customerNumber}/${orderNumber}`);
  return res.data;
};
